"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Baobab_Context_1 = require("../Baobab/Baobab-Context");
var __1 = require("..");
function createNodeData(context, childProps, nodeDeclaration, logNode) {
    return context.parentNode ?
        __1.createChildData(childProps, nodeDeclaration, logNode) :
        __1.createRootData(childProps, nodeDeclaration, logNode);
}
function wrapAction(refBaobabNode, key, eventDeclaration, logEvent) {
    return function () {
        var eventArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            eventArgs[_i] = arguments[_i];
        }
        var componentProps = refBaobabNode.current.childProps;
        var componentEvent = componentProps[key];
        var simpleDeclaration = __assign({}, eventDeclaration);
        if (__1.isEventDataAttrsConstructor(eventDeclaration.data)) {
            simpleDeclaration.data = eventDeclaration.data({ props: componentProps }, eventArgs);
        }
        var withEvent = logEvent(simpleDeclaration, eventArgs, __assign(__assign({}, refBaobabNode.current.childProps), refBaobabNode.current.extraChildProps));
        var result;
        if (typeof componentEvent === 'function') {
            result = componentEvent.call.apply(componentEvent, __spread([this], eventArgs, [{ withEvent: withEvent }]));
        }
        else if (typeof componentEvent !== 'undefined') {
            throw new Error("\u0412\u044B \u043F\u044B\u0442\u0430\u0435\u0442\u0435\u0441\u044C \u0432\u044B\u0437\u0432\u0430\u0442\u044C \u0441\u043E\u0431\u044B\u0442\u0438\u0435 " + key + ". \u041D\u043E \u044D\u0442\u043E " + typeof componentEvent + ", \u0441\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C \"" + componentEvent + "\"");
        }
        return result;
    };
}
function wrapActions(refBaobabNode, logEvent) {
    var result = {};
    var eventDeclarations = refBaobabNode.current.nodeData.events;
    for (var key in eventDeclarations) {
        var eventDeclaration = eventDeclarations[key];
        if (__1.isEventDeclaration(eventDeclaration)) {
            result[key] = wrapAction(refBaobabNode, key, eventDeclaration, logEvent);
        }
    }
    return result;
}
exports.wrapActions = wrapActions;
function shouldRecreateNode(node, nodeData, parentNode) {
    return !node || !__1.areEqualsNodes(node, nodeData, parentNode);
}
exports.shouldRecreateNode = shouldRecreateNode;
exports.BaobabNode = function (_a) {
    var nodeDeclaration = _a.nodeDeclaration, logNode = _a.logNode, children = _a.children, childProps = _a.childProps;
    var _b, _c;
    var context = React.useContext(Baobab_Context_1.BaobabContext);
    var nodeData = context ?
        createNodeData(context, childProps, nodeDeclaration, logNode) :
        {};
    var ref = React.useRef({
        node: undefined,
        childProps: childProps,
        extraChildProps: {},
        nodeData: nodeData,
    });
    var shouldRecreate = shouldRecreateNode(ref.current.node, nodeData, (_b = context) === null || _b === void 0 ? void 0 : _b.parentNode);
    if (shouldRecreate) {
        ref.current.nodeData = nodeData;
    }
    ref.current.childProps = childProps;
    var BaobabNode = __1.useBaobab(ref.current.nodeData);
    if (shouldRecreate) {
        var node = BaobabNode.node, logEvent = BaobabNode.logEvent;
        ref.current.node = node;
        ref.current.extraChildProps = ref.current.nodeData.events ?
            wrapActions(ref, logEvent) :
            {};
        var extra = nodeDeclaration.extra;
        if (extra) {
            if (extra.id) {
                ref.current.extraChildProps.baobabId = node && node.id;
                ref.current.extraChildProps.baobabNode = node;
            }
            if (extra.withLogger) {
                ref.current.extraChildProps.baobabNodeLogger = (_c = context) === null || _c === void 0 ? void 0 : _c.logger;
            }
        }
    }
    if (!context) {
        return (React.createElement(React.Fragment, null, children(__assign({}, childProps))));
    }
    return (React.createElement(Baobab_Context_1.BaobabContext.Provider, { value: BaobabNode.nextContext }, children(Object.assign({}, childProps, ref.current.extraChildProps))));
};
exports.BaobabNode.isBaobabNode = true;
